import styled from 'styled-components';

export const ForwardArrowStyles = styled.button`
  background-color: #ffffff;
  border: none;
  cursor: pointer;
  padding: 0px;
`;
export const ForwardArrowImageStyles = styled.img`
  height: 30px;
  margin-top: 5px;
  transform: rotate(180deg);
`;
